import { companyRequest } from '@/company/api';
import { writeWorkspaceHash } from '@/lib/chat-links';
import { routeFor } from '../navigation';
import { noteEditorOpened } from './preview/live-build';

export type AppChatSelection = { artifactId: string; versionId: string; revisionId: string };

/**
 * Change with Chat: this person's own editing chat for the saved App opens with
 * the App beside it. The Share sheet sends editors here to change what the App
 * runs on; Back returns to where they were.
 */
export async function openAppChat(selection: AppChatSelection): Promise<{ threadId: string }> {
  const query = new URLSearchParams({
    versionId: selection.versionId,
    revisionId: selection.revisionId,
  });
  const { threadId, editingId } = await companyRequest<{ threadId: string; editingId: string }>(
    `/api/v1/company/apps/${encodeURIComponent(selection.artifactId)}/chat?${query}`,
    'GET',
  );
  if (
    ![threadId, editingId].every(
      (id) => typeof id === 'string' && /^[A-Za-z0-9_-]{1,128}$/.test(id),
    )
  )
    throw new Error('app_chat_unavailable');
  // A new opening: the chat's builds from before it (an earlier opening of this same editor included) never replace it.
  noteEditorOpened(`${threadId}:${editingId}`);
  writeWorkspaceHash(
    routeFor('chat', { kind: 'app-preview', id: editingId, full: false, editor: true }, threadId),
  );
  return { threadId };
}
